import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import Layout from './layout'
import Subpages from './public/subpages'
import GenDuo from './public/genduo'
import NavLink from './navLink'
import { BASE_URL, getZxslList } from '../api/api'

SwiperCore.use([Autoplay, Navigation])

// 普通新闻链接：有外链走外链，否则走站内详情
const newsLinkProps = (item = {}) =>
  item.outlink
    ? { to: item.outlink, isOutLink: true }
    : { to: `/wzxq/id/${item.id}`, isOutLink: false }

// 广告位链接：统一跳转外链（无外链时回退到文章地址）
const adLinkProps = (item = {}) => ({ to: item.outlink || item.url || '/', isOutLink: true })

// 区块标题：蓝色标题 + 更多 + 蓝色下划线
const SectionHeader = ({ name, item }) => (
  <div className="flex items-end justify-between border-b-2 border-[#0189D5] pb-2">
    <h2 className="text-[#0189D5] text-[22px] font-bold font-alhpr leading-none">{name}</h2>
    <GenDuo {...(item ? { href: newsLinkProps(item).to } : {})} />
  </div>
)

// 广告位：展示图片并跳转外链，无数据时回退蓝色占位
const AdBox = ({ item, className = '' }) => {
  if (!item) {
    return (
      <div
        className={`bg-[#0189D5] text-white font-alhpr flex items-center justify-center ${className}`}
      >
        广告位
      </div>
    )
  }
  return (
    <NavLink {...adLinkProps(item)} className="block">
      {item.image ? (
        <img
          src={`${BASE_URL}${item.image}`}
          alt={item.title || ''}
          className={`w-full object-cover ${className}`}
        />
      ) : (
        <div
          className={`bg-[#0189D5] text-white font-alhpr flex items-center justify-center ${className}`}
        >
          广告位
        </div>
      )}
    </NavLink>
  )
}

// 头条大图轮播（参考 home/chart 的 Swiper 样式）
const HeadCarousel = ({ list = [] }) => {
  const [index, setIndex] = useState(0)

  if (!list.length) {
    return (
      <div className="relative w-full shrink-0 lg:w-[680px]">
        <div className="h-[220px] w-full bg-gray-200 lg:h-[380px]" />
      </div>
    )
  }

  const current = list[index] || {}

  return (
    <Swiper
      className="zxsl-carousel w-full shrink-0 lg:w-[680px]"
      spaceBetween={0}
      slidesPerView={1}
      navigation
      autoplay={{ delay: 3000 }}
      onSlideChange={({ activeIndex }) => setIndex(activeIndex)}
    >
      {list.map((item, key) => (
        <SwiperSlide key={item.id || key}>
          <NavLink {...newsLinkProps(item)} className="block">
            {item.image ? (
              <img
                src={`${BASE_URL}${item.image}`}
                alt={item.title || ''}
                className="h-[220px] w-full object-cover lg:h-[380px]"
              />
            ) : (
              <div className="h-[220px] w-full bg-gray-200 lg:h-[380px]" />
            )}
          </NavLink>
        </SwiperSlide>
      ))}
      <div className="absolute bottom-0 left-0 right-0 z-10 flex">
        <NavLink
          {...newsLinkProps(current)}
          className="flex-1 truncate bg-[#0189D5] px-4 py-3 text-sm text-white font-alhpr"
        >
          {current.title}
        </NavLink>
        <span className="w-[54px] shrink-0 bg-black py-3 text-center text-sm text-white">
          {index + 1}/{list.length}
        </span>
      </div>
    </Swiper>
  )
}

// 文字列表条目（财经/生活/科技/家电）
const TextNewsItem = ({ item }) => (
  <li className="flex items-center justify-between">
    <NavLink
      {...newsLinkProps(item)}
      className="flex min-w-0 flex-1 items-center text-sm text-[#0189D5] font-sourceHan"
    >
      <span className="mr-2 text-[#0189D5]">·</span>
      <span className="truncate text-[#000]">{item.title}</span>
    </NavLink>
    <span className="ml-3 shrink-0 text-xs text-[#999999]">{item.publishtime_text}</span>
  </li>
)

const Zixunsulan = () => {
  const [data, setData] = useState({})

  useEffect(() => {
    getZxslList().then(res => {
      setData(res?.data || {})
    })
  }, [])

  const {
    zximgNew = [],
    zxsnewsList = [],
    zxxnewsList = [],
    zxcjList = [],
    zxshList = [],
    zxkjList = [],
    zxjjList = [],
    zxjkList = [],
    zxjdList = [],
    zxadaList = [],
    zxadbList = [],
    zxadcList = []
  } = data || {}

  const rightTop = zxsnewsList || []
  const rightBottom = zxxnewsList || []

  const columns = [
    { name: '财经', list: zxcjList },
    { name: '生活', list: zxshList },
    { name: '科技', list: zxkjList }
  ]

  // 家电：前两条作为大图，其余作为文字列表
  const applianceImgs = zxjdList.slice(0, 2)
  const applianceList = zxjdList.slice(2)

  return (
    <Layout white>
      <Subpages name={data?.zxbannerList?.[0]?.title} className="px-4 pb-10 lg:px-0 lg:pb-20">
        {/* 头条：左侧大图轮播 + 右侧两条新闻 */}
        <section className="flex flex-col gap-5 lg:flex-row lg:gap-8 lg:items-center">
          <HeadCarousel list={zximgNew} />
          <div className="flex flex-1 flex-col justify-between lg:h-[390px] max-w-[480px]">
            <div>
              {rightTop.map((item, idx) => (
                <>
                  {idx === 0 ? (
                    <NavLink
                      {...newsLinkProps(item)}
                      className=" line-clamp-1 text-[20px] mb-[10px] font-bold text-[#0189d5] font-alhpr"
                    >
                      {item.title}
                    </NavLink>
                  ) : (
                    <NavLink
                      {...newsLinkProps(item)}
                      className=" line-clamp-1 text-sm leading-7 text-[#000] font-sourceHan"
                    >
                      {item.description}
                    </NavLink>
                  )}
                </>
              ))}
            </div>
            <div className="border-t border-[#E7E7E7] pt-[10px]"></div>
            <div>
              {rightBottom.map((item, idx) => (
                <>
                  {idx === 0 ? (
                    <NavLink
                      {...newsLinkProps(item)}
                      className="line-clamp-1 text-[20px] mb-[10px] font-bold text-[#0189d5] font-alhpr"
                    >
                      {item.title}
                    </NavLink>
                  ) : (
                    <NavLink
                      {...newsLinkProps(item)}
                      className=" line-clamp-1 text-sm leading-7 text-[#000] font-sourceHan"
                    >
                      {item.description}
                    </NavLink>
                  )}
                </>
              ))}
            </div>
          </div>
        </section>

        {/* 广告位 1（3 个） */}
        <section className="mt-8 grid grid-cols-3 gap-3 lg:mt-10 lg:gap-6">
          {[0, 1, 2].map(i => (
            <AdBox key={i} item={zxadaList[i]} className="h-14 text-base lg:h-20 lg:text-2xl" />
          ))}
        </section>

        {/* 财经 / 生活 / 科技 三栏 */}
        <section className="mt-8 grid grid-cols-1 gap-8 lg:mt-12 lg:grid-cols-3 lg:gap-10">
          {columns.map(col => (
            <div key={col.name}>
              <SectionHeader name={col.name} item={col.list[0]} />
              <ul className="mt-4 space-y-3">
                {col.list.map(item => (
                  <TextNewsItem key={item.id} item={item} />
                ))}
              </ul>
            </div>
          ))}
        </section>

        {/* 广告位 2（通栏 1 个） */}
        <AdBox
          item={zxadbList[0]}
          className="mt-8 h-[60px] text-base lg:mt-12 lg:h-[90px] lg:text-2xl"
        />

        {/* 家居：四张图片卡片 */}
        <section className="mt-8 lg:mt-12">
          <SectionHeader name="家居" item={zxjjList[0]} />
          <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
            {zxjjList.slice(0, 4).map(card => (
              <NavLink key={card.id} {...newsLinkProps(card)} className="block">
                {card.image ? (
                  <img
                    src={`${BASE_URL}${card.image}`}
                    alt={card.title || ''}
                    className="h-[110px] w-full object-cover lg:h-[150px]"
                  />
                ) : (
                  <div className="h-[110px] w-full bg-gray-200 lg:h-[150px]" />
                )}
                <p className="mt-3 truncate text-sm text-[#333333] font-sourceHan">{card.title}</p>
              </NavLink>
            ))}
          </div>
        </section>

        {/* 健康 / 家电 两栏 */}
        <section className="mt-8 grid grid-cols-1 gap-8 lg:mt-12 lg:grid-cols-2 lg:gap-12">
          {/* 健康 */}
          <div>
            <SectionHeader name="健康" item={zxjkList[0]} />
            <ul className="mt-6 space-y-6">
              {zxjkList.map(item => (
                <li key={item.id}>
                  <NavLink {...newsLinkProps(item)} className="flex gap-4">
                    {item.image ? (
                      <img
                        src={`${BASE_URL}${item.image}`}
                        alt={item.title || ''}
                        className="h-[70px] w-[110px] shrink-0 object-cover lg:h-[90px] lg:w-[140px]"
                      />
                    ) : (
                      <div className="h-[70px] w-[110px] shrink-0 bg-gray-200 lg:h-[90px] lg:w-[140px]" />
                    )}
                    <div className="min-w-0 flex-1">
                      <h4 className="line-clamp-2 text-[16px] font-bold text-[#0189D5] font-alhpr">
                        {item.title}
                      </h4>
                      <p className="mt-2 line-clamp-3 text-xs leading-5 text-[#888888] font-sourceHan">
                        {item.description}
                      </p>
                    </div>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* 家电 */}
          <div>
            <SectionHeader name="家电" item={zxjdList[0]} />
            <div className="mt-6 space-y-5">
              {applianceImgs.map(item => (
                <NavLink key={item.id} {...newsLinkProps(item)} className="relative block">
                  {item.image ? (
                    <img
                      src={`${BASE_URL}${item.image}`}
                      alt={item.title || ''}
                      className="h-[160px] w-full object-cover lg:h-[180px]"
                    />
                  ) : (
                    <div className="h-[160px] w-full bg-gray-200 lg:h-[180px]" />
                  )}
                  <div className="absolute bottom-0 left-0 right-0 truncate bg-[#0189D5] px-4 py-2 text-sm text-white font-alhpr">
                    {item.title}
                  </div>
                </NavLink>
              ))}
            </div>
            <ul className="mt-5 space-y-3">
              {applianceList.map(item => (
                <TextNewsItem key={item.id} item={item} />
              ))}
            </ul>
          </div>
        </section>

        {/* 广告位 3（3 个） */}
        <section className="mt-8 grid grid-cols-3 gap-3 lg:mt-12 lg:gap-6">
          {[0, 1, 2].map(i => (
            <AdBox key={i} item={zxadcList[i]} className="h-14 text-base lg:h-20 lg:text-2xl" />
          ))}
        </section>
      </Subpages>
    </Layout>
  )
}

export default Zixunsulan
